import productItemSimilary from "./productItemSimilary"
export default productItemSimilary;
